import commonVars from "./_common.mjs";
function self() {
  return commonVars;
}
const spaceLight = {
  name: 'Space',
  self
};
export default spaceLight;